import { global } from "@shared/libs/Global";

export const getCode = (code: string) => {
  let param: string;
  switch (code.toLowerCase()) {
    case "mas_biz":
      param = `
                select mb.cd_biz code, mb.nm_biz name 
                from mas_biz mb 
                left outer join mas_dept md on mb.cd_firm = md.cd_firm and mb.cd_biz = md.cd_biz 
                left outer join mas_emp me on md.cd_firm = me.cd_firm and md.cd_dept = me.cd_dept 
                where mb.cd_firm = '${global.getState().userInfo.cd_firm}' 
                and mb.yn_use = 'Y' 
                group by mb.cd_biz, mb.nm_biz, mb.no_seq 
                order by mb.no_seq, mb.cd_biz
            `;
      break;
    case "mas_gl":
      param = `select cd_gl code, dc_rmk name from mas_gl where cd_firm = '${
        global.getState().userInfo.cd_firm
      }'`;
      break;
    case "mas_gp":
      param = `select cd_gp code, nm_gp name from mas_gp where cd_firm = '${
        global.getState().userInfo.cd_firm
      }' and yn_use = 'Y'`;
      break;
    case "hrs_lncode":
      param = `
                select h.cd_lncode code, h.nm_lncode name, h.tp_ln 
                from hrs_lncode h 
                where h.cd_firm = '${global.getState().userInfo.cd_firm}' 
                order by h.cd_lncode asc
            `;
      break;
    case "mas_codel_hrs404":
      param = `
                select h.cd_flag code, h.nm_flag name 
                from mas_codel h 
                where h.cd_firm = '${global.getState().userInfo.cd_firm}' 
                and h.cd_clas = 'cd_clas' 
                and h.cd_flag in ('2', '3')
            `;
      break;
    case "mas_cc":
      param = `
                select cd_cc code, nm_cc name, cd_biz 
                from mas_cc 
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "prd_op":
      param = `
                select cd_op code, nm_op name, cd_op_p 
                from prd_op 
                where cd_firm = '${
                  global.getState().userInfo.cd_firm
                }' and yn_use = 'Y'
            `;
      break;
    case "mas_fin":
      param = `
                select cd_fin code, nm_fin name 
                from mas_fintypeh 
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "mas_wotype":
      param = `
                select cd_wo code, nm_wo name 
                from mas_wotype 
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "prd_equip":
      param = `
                select cd_equip code, nm_equip name 
                from prd_equip 
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "prt_equip":
      param = `
                select cd_equip code, nm_equip name, cd_op_p, fg_op, cd_op 
                from prt_equip 
                where cd_firm = '${
                  global.getState().userInfo.cd_firm
                }' and yn_use = 'Y'
            `;
      break;
    case "mas_sctype":
      param = `
                select cd_sct as code, nm_sct as name 
                from mas_sctype 
                where cd_firm = '${
                  global.getState().userInfo.cd_firm
                }' and yn_use = 'Y'
            `;
      break;
    case "mas_sotype":
      param = `
                    select cd_so as code, nm_so as name, COALESCE(cd_biz, '') as cd_biz 
                    from mas_sotype 
                    where cd_firm = '${
                      global.getState().userInfo.cd_firm
                    }' and yn_use = 'Y'
                `;
      break;
    case "mas_potype":
      param = `
                    select cd_po as code, nm_po as name, COALESCE(cd_biz, '') as cd_biz 
                    from mas_potype 
                    where cd_firm = '${
                      global.getState().userInfo.cd_firm
                    }' and yn_use = 'Y'
                `;
      break;
    case "mas_iotype":
      param = `
                    select cd_io as code, nm_io as name 
                    from mas_iotype 
                    where cd_firm = '${
                      global.getState().userInfo.cd_firm
                    }' and yn_use = 'Y'
                `;
      break;
    case "speccode":
      param = `
                select cd_flag as code, nm_flag as name 
                from mas_codel 
                where cd_firm = '${global.getState().userInfo.cd_firm}' 
                and cd_clas = 'mas149' 
                and yn_use = 'Y' 
                and cd_flag between 'qt01' and 'qt10'
            `;
      break;
    case "mas_item":
      param = `
                select cd_item, nm_item
                from mas_item 
                where cd_firm = '${
                  global.getState().userInfo.cd_firm
                }' and yn_use = 'Y'
            `;
      break;
    case "mas_cust":
      // 엑셀 업로드 PK(cd_cust) 중복 판정용. 미사용(yn_use='N') 거래처도
      // 이미 저장된 데이터이므로 제외하지 않는다.
      param = `
                select cd_cust, nm_cust
                from mas_cust
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "mas_umitem":
      // 단가 엑셀 업로드 PK(cd_module + tp_um + cd_exch + cd_item + dt_start) 중복 판정용
      param = `
                select cd_module, tp_um, cd_exch, cd_item, dt_start
                from mas_umitem
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "mas_umcust":
      // 거래처별단가 엑셀 업로드 PK(cd_module + cd_cust + cd_item + tp_um + cd_exch + dt_start) 중복 판정용
      param = `
                select cd_module, cd_cust, cd_item, tp_um, cd_exch, dt_start
                from mas_umcust
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "mas_custitem":
      param = `
                select cd_cust, cd_item, cd_item_cust
                from mas_custitem 
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "popup_cust":
      param = `
                select cd_cust code, nm_cust name
                from mas_cust 
                where cd_firm = '${
                  global.getState().userInfo.cd_firm
                }' and yn_use = 'Y'
            `;
      break;
    case "popup_custitem":
      param = `
                select cd_item_cust code, nm_item_cust name
                from mas_custitem
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "popup_item":
      param = `
                select cd_item code, nm_item name
                from mas_item
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "popup_wh":
      param = `
                select cd_wh code, nm_wh name
                from mas_wh 
                where cd_firm = '${
                  global.getState().userInfo.cd_firm
                }' and yn_use = 'Y'
            `;
      break;
    case "popup_wh_bf":
      param = `
                select cd_wh code, nm_wh name
                from mas_wh 
                where cd_firm = '${
                  global.getState().userInfo.cd_firm
                }' and yn_use = 'Y'
                   and yn_bf = 'Y'
            `;
      break;
    case "popup_emp":
      param = `
                select cd_emp code, nm_emp name
                from mas_emp 
                where cd_firm = '${
                  global.getState().userInfo.cd_firm
                }' and yn_use = 'Y'
            `;
      break;
    case "popup_style":
      param = `
                select no_style code, nm_style name
                from mas_styleh_tex
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "popup_pjt":
      param = `
                select cd_pjt code, nm_pjt name
                from pms_pjth
                where cd_firm = '${global.getState().userInfo.cd_firm}'
            `;
      break;
    case "mtl_asset_use":
      param = `
                  select a.no_asset, 
        coalesce(u.no_line,0) no_line, 
        a.cd_have, 
        a.dt_rcv,
        u.dt_start, 
        u.dt_return_plan, 
        u.dt_end,
        u.cd_emp,
        u.nm_emp,
        u.cd_dept,
        u.nm_dept  
        from mtl_asset a
        left outer join mtl_asset_use u on a.cd_firm = u.cd_firm and a.no_asset = u.no_asset and u.yn_end = 'Y' 
                  where a.cd_firm = '${
                    global.getState().userInfo.cd_firm
                  }' and yn_use = 'Y'
              `;
      break;
    case "prd_putitem_pos":
      param = `
        select  p.cd_pos,
                p.no_line,
                p.cd_biz,
                p.cd_item,
                p.dc_rmk,
                p.cd_equip,
                p.cd_matl,
                p.qt_unit
        from prd_putitem_pos p 
        where p.cd_firm = '${global.getState().userInfo.cd_firm}' 
              `;
      break;
    default:
      param = `select code, name, cd_clas, no_seq, dc_ref1, dc_ref 
          from  (
                select
                    cd_flag as code,        
                    nm_flag as name,    
                    cd_clas,
                    no_seq,    
                    dc_ref1,
                    dc_ref,
                    no_seq_sort
                from mas_codel
                where ( (cd_firm = '${
                  global.getState().userInfo.cd_firm
                }') or ('${
                  global.getState().userInfo.cd_user
                }' = 'snadmin' and cd_firm = '0000'))
                    and cd_clas = '${code}'
                    and yn_use = 'Y'
        
                union all
        
                select cd_code as code, nm_code as name, cd_clas, 0 no_seq, '' dc_ref1, '' dc_ref, 0 no_seq_sort
                from mas_code_search where cd_clas = '${code}'
                
                union all
  
                select	code, name, '${code}' cd_clas, 0 no_seq, '' dc_ref1, '' dc_ref, 0 no_seq_sort
                from	(
                            select	'f' code, '미승인' name
                            union 	all
                            select	'r' code, '미마감(승인)' name
                            union 	all
                            select	'c' code, '마감' name
                        ) a
                where ('${code}' = 'sal_stso')
        ) a
        order by no_seq_sort, code, name`;
  }
  return param;
};
